import { isModulePresentable } from '../../../enums/module.enums';

export const isModuleValid = (module) => module.published && isModulePresentable(module);
export const findValidModule = (session) => session.modules.find(isModuleValid);
export const hasValidModule = (session) => session.modules.some(isModuleValid);
